import Vue from 'vue'
import Vuex from 'vuex'
import initdata from './modules/initdata'
import mc from './modules/mc'
import daijia from './modules/daijia/daijia'
import userCenter from './modules/userCenter'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    initdata,
    mc,
    daijia,
    userCenter
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js